import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
    },
    {
      path: '/Data',
      component: () => import('@/views/Data.vue'),
      redirect: 'FrontPage',
      children: [
        {
          path: '/FrontPage',
          component: () => import('@/components/Data/FrontPage.vue'),
        },
        // OrderManagement
        {
          path: '/OrderProcessing',
          component: () => import('@/components/Data/OrderManagement/OrderProcessing.vue'),
          meta: {
            // 是否授权
            isAuth: true
          }
        },
        {
          path: '/OrderRecord',
          component: () => import('@/components/Data/OrderManagement/OrderRecord.vue'),
          // meta: {
          //   // 是否授权
          //   isAuth: true
          // }
        },
        // CommodityManagement
        {
          path: '/CommodityManagement',
          component: () => import('@/components/Data/CommodityManagement.vue'),
          meta: {
            // 是否授权
            isAuth: true
          }
        },
        {
          path: '/CommodityManagementHospitalVer',
          component: () => import('@/components/Data/CommodityManagementHospitalVer.vue'),
          meta: {
            // 是否授权
            isAuth: true
          }
        },
        {
          path: '/DataAnalysis',
          component: () => import('@/components/Data/DataAnalysis.vue'),
          meta: {
            // 是否授权
            isAuth: true
          }
        },
        {
          path: '/CommodityCheckHospitalVer',
          component: () => import('@/components/Data/CommodityCheckHospitalVer.vue'),
          meta: {
            // 是否授权
            isAuth: true
          }
        },
        {
          path: '/ProblemFeedBack',
          component: () => import('@/components/Data/ProblemFeedBack.vue'),
          // meta: {
          //   // 是否授权
          //   isAuth: true
          // }
        },
        {
          path: '/QualificationManagement',
          component: () => import('@/components/Data/QualificationManagement.vue'),
          // meta: {
          //   // 是否授权
          //   isAuth: true
          // }
        },
        {
          path: '/QualificationHospitalVer',
          component: () => import('@/components/Data/QualificationHospitalVer.vue'),
          meta: {
            // 是否授权
            isAuth: true
          }
        },
        {
          path: '/DataCharts',
          component: () => import('@/components/Data/DataVisualization/DataCharts.vue'),
          meta: {
            // 是否授权
            isAuth: true
          }
        },
        {
          path: '/ExcelExport',
          component: () => import('@/components/Data/DataVisualization/ExcelExport.vue'),
          meta: {
            // 是否授权
            isAuth: true
          }
        },
        {
          path: '/PromotionsManagement',
          component: () => import('@/components/Data/PromotionsManagement.vue'),
          meta: {
            // 是否授权
            isAuth: true
          }
        },
        {
          path: '/ExportTaskManagement',
          component: () => import('@/components/Data/ExportTaskManagement.vue'),
          meta: {
            // 是否授权
            isAuth: true
          }
        },
      ],
    },
    // {
    //   path: '/ExpressWeb',
    //   name: 'ExpressWeb',
    //   component: () => import('@/views/ExpressWeb.vue'),
    // }
  ]
})


router.beforeEach((to, from, next) => {
  //  判断是否需要鉴定一下权限
  if (to.meta.isAuth) {
    const profile = sessionStorage.getItem("profile");
    if (!profile) {
      alert('请先登录');
      next('/');
      return;
    }
    
    const userProfile = JSON.parse(profile);
    
    if (to.path === "/CommodityCheckHospitalVer") {
      if (userProfile.role === 'checker') {
        next()
      } else {
        alert('无权限查看');
        window.history.go(-1);
      }
    }
    else if (to.path === "/QualificationHospitalVer") {
      if (userProfile.role === 'checker') {
        next()
      } else {
        alert('无权限查看');
        window.history.go(-1);
      }
    }

    else if (to.path === "/CommodityManagementHospitalVer") {
      if (userProfile.role === 'checker') {
        next()
      } else {
        alert('无权限查看');
        window.history.go(-1);
      }
    }

    else if (to.path === "/OrderProcessing") {
      if (userProfile.role === 'admin' || userProfile.role === 'worker') {
        next()
      } else {
        alert('无权限查看');
        window.history.go(-1);
      }
    }

    else if (to.path === "/DataCharts") {
      if (userProfile.role === 'admin' || userProfile.role === 'checker') {
        next()
      } else {
        alert('无权限查看');
        window.history.go(-1);
      }
    }

    else if (to.path === "/ExcelExport") {
      if (userProfile.role === 'admin' || userProfile.role === 'checker') {
        next()
      } else {
        alert('无权限查看');
        window.history.go(-1);
      }
    }

    else if (to.path === "/PromotionsManagement") {
      if (userProfile.role === 'admin' || userProfile.role === 'checker') {
        next()
      } else {
        alert('无权限查看');
        window.history.go(-1);
      }
    }

    else if (to.path === "/ExportTaskManagement") {
      if (userProfile.role === 'admin' || userProfile.role === 'checker') {
        next()
      } else {
        alert('无权限查看');
        window.history.go(-1);
      }
    }

    else {
      if (userProfile.role === 'admin') {
        next()
      } else {
        alert('无权限查看');
        window.history.go(-1);
      }
    }
  } else {
    next();
  }
})


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
